import { useCallback } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { AsyncOperationProgress } from "@/components/progress";
import { useAsyncOperationProgress } from "@/components/progress";

interface QuestionnaireAttachmentProgressDialogProps {
  open: boolean;
  operationProgress: ReturnType<typeof useAsyncOperationProgress>;
  currentItemLabel?: string;
  translationKey: string;
  onClose: (open?: boolean) => void;
}

export function QuestionnaireAttachmentProgressDialog({
  open,
  operationProgress,
  currentItemLabel,
  translationKey,
  onClose,
}: QuestionnaireAttachmentProgressDialogProps) {
  const handleAsyncClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-4xl max-h-[90vh] flex flex-col">
        <AsyncOperationProgress
          operationProgress={operationProgress}
          currentItemLabel={currentItemLabel}
          onClose={handleAsyncClose}
          translationKey={translationKey}
        />
      </DialogContent>
    </Dialog>
  );
}
